<template>
  <div class="chat-input-container">
    <div class="chat-seperator-line" />
    <div class="message-input-section">
      <!-- <div
        class="filter-icon-container"
        @click="toggleFilterKeybord"
        v-if="filterIconVisible"
      >
        <div class="filterplate" />
        <div class="filter-icon" />
        <div class="rectangle-div" />
        <div class="filter-child1" />
        <div class="filter-child2" />
        <div class="filter-child3" />
      </div>

      <div
        class="keyboard"
        v-if="!filterIconVisible"
        @click="toggleFilterKeybord"
      >
        <div class="keyboard-child" />
        <img
          class="string-manipulator-icon"
          loading="lazy"
          alt=""
          src="../assets/string-manipulator.svg"
        />
      </div> -->
      <div class="keyboard-instance">
        <div class="text">
          <div class="input-wrapper" @click="focusInput">
            <div
              class="input-field large-reg black-default"
              :text-content.prop="msg"
              @input="updateText"
              ref="input"
              @keydown.enter="handleEnter"
              id="message-text"
              contenteditable
              placeholder="Message..."
            ></div>
          </div>
          <div class="send-btn-container">
            <div class="send">
              <img
                id="send-button"
                class="sendicon"
                alt=""
                :src="sendButtonSrc"
                @click="sendMessage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <MainFilters v-if="!filterIconVisible"></MainFilters>
</template>

<script setup>
import { computed, ref } from "vue";
import { useMessagesStore } from "@/stores/useMessagesStore";
import sendInactive from "@/assets/send_inactive.svg";
import sendActive from "@/assets/send_active.svg";
import MainFilters from "./filters/MainFilters.vue";

const input = ref(null);
const msg = ref("");
const filterIconVisible = ref(true);
const {sendMsg} = useMessagesStore();

// Have msg mirror input text whenever it changes
function updateText(event) {
  msg.value = event.target.innerText;
}

function focusInput() {
  filterIconVisible.value = true;
  if (input.value) input.value.focus();
}

// Grey button when msg is empty, blue button otherwise
const sendButtonSrc = computed(() => {
  return msg.value == "" ? sendInactive : sendActive;
});

// Send message and reset msg and input to empty string
function sendMessage() {
  if (msg.value != "") {
    sendMsg(msg.value);
    msg.value = "";
    if (input.value) input.value.innerText = "";
  }
}

// Send message when enter is pressed
function handleEnter(event) {
  event.preventDefault();
  sendMessage();
}

// function toggleFilterKeybord() {
//   filterIconVisible.value = !filterIconVisible.value;
// }
</script>

<style scoped>
#message-text {
  width: 100%;
  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
  max-height: 100px;
}

#message-text::-webkit-scrollbar {
  display: none;
}

#message-text:focus {
  outline: none;
}

#message-text:empty:before {
  content: attr(placeholder);
  color: var(--black-light);
}

#send-button {
  cursor: pointer;
}

.keyboard-child {
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  border-radius: 4.25px;
  background-color: var(--primary-accent-base);
  width: 30px;
  height: 30px;
}
.string-manipulator-icon {
  position: absolute;
  top: 16.5px;
  left: 13.5px;
  width: 21px;
  height: 15.5px;
  z-index: 1;
}
.keyboard {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.chat-input-container {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  text-align: left;
  color: var(--black-default);
}

.chat-seperator-line {
  align-self: stretch;
  height: 1px;
  position: relative;
  border-top: 1px solid var(--gray-medium);
  box-sizing: border-box;
}

.message-input-section {
  align-self: stretch;
  border-radius: var(--br-9xs);
  background-color: var(--white-default);
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  padding: var(--padding-7xs);
  box-sizing: border-box;
  gap: var(--gap-7xs);
  max-width: 100%;
  margin-top: -0.5px;
}

.filter-icon-container {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  .filterplate {
    position: absolute;
    top: calc(50% - 24px);
    left: calc(50% - 24px);
    width: 100%;
    height: 100%;
  }

  .filter-icon {
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    border-radius: var(--br-5xl);
    background-color: var(--primary-accent-base);
    width: 30px;
    height: 30px;
  }

  .rectangle-div {
    position: absolute;
    top: calc(50% - 4.3px);
    left: calc(50% - 8.5px);
    border: 1px solid var(--white-dark);
    box-sizing: border-box;
    width: 12px;
    height: 1.7px;
    z-index: 2;
  }

  .filter-child1 {
    position: absolute;
    top: calc(50% + 2.7px);
    left: calc(50% - 3.5px);
    border: 1px solid var(--white-dark);
    box-sizing: border-box;
    width: 12px;
    height: 1.7px;
    z-index: 2;
  }

  .filter-child2 {
    position: absolute;
    top: calc(50% + 0.5px);
    left: calc(50% - 8.5px);
    border-radius: var(--br-7xs);
    border: 1.7px solid var(--white-dark);
    box-sizing: border-box;
    width: 6px;
    height: 6px;
  }

  .filter-child3 {
    position: absolute;
    top: calc(50% - 6.5px);
    left: calc(50% + 2.5px);
    border-radius: var(--br-7xs);
    border: 1.7px solid var(--white-dark);
    box-sizing: border-box;
    width: 6px;
    height: 6px;
  }
}

.keyboard-instance {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-11xs) 0px;
  box-sizing: border-box;
  min-width: 226px;
  max-width: 100%;

  .text {
    align-self: stretch;
    border-radius: var(--br-9xs);
    border: 1px solid var(--gray-medium);
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 0px 10px;

    .input-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: var(--padding-7xs) 0px 0px;

      .input-field {
        align-self: stretch;
        position: relative;
        line-height: 23px;
        font-weight: 400;
        padding: 4px 0px 0px 0px;
        overflow-wrap: anywhere;
      }
    }

    .send-btn-container {
      align-self: stretch;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-end;

      .send {
        min-height: 44px;
        max-height: 100px;
        width: 48px;
        position: relative;
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        align-items: flex-end;

        .sendicon {
          position: absolute;
          bottom: 10px;
          left: calc(50% - 12px);
          width: 24px;
          height: 24px;
          z-index: 1;
        }
      }
    }
  }
}

</style>
